ch-flexible-layout-render,
.ch-flexible-layout-render-slot {
  display: contents;
}